import { reviews } from '@/mocks/galData';

export default function About() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm text-primary-700">
            关于本站 · 用户口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            专注角色解读，陪你看懂泡在我家的辣妹
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
            我们是一群喜欢这部作品的观众，把女主是谁、男主设定、泡在我家的辣妹人物关系整理成清晰易懂的入坑指南，分享给同样喜欢它的你。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-3xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-xl text-primary-600">我们的定位</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              面向刚接触这部作品的新人，提供从角色到人物关系的完整解读。不做剧情搬运，只做让你更好入坑的整理与科普。
            </p>
          </div>
          <div className="rounded-3xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-xl text-accent-600">内容原则</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              角色设定与人物关系梳理，力求准确、清晰、有温度。所有内容均为爱好者视角的解读，帮助新读者快速建立认知框架。
            </p>
          </div>
          <div className="rounded-3xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-xl text-secondary-700">内容组织</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              通过女主介绍、男主设定、人物关系图与角色图鉴四个板块，把复杂的信息分层呈现，让你从零开始也能轻松看懂。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {reviews.map((review) => (
            <figure
              key={review.name}
              className="rounded-3xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {[1, 2, 3, 4, 5].map((n) => (
                  <i key={n} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-7 text-foreground-700">
                「{review.text}」
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={`${review.name}的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-950">{review.name}</div>
                  <div className="text-xs text-foreground-600">{review.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}